import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-heading font-black text-fog-dark/30 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <i className="ri-gamepad-line text-5xl text-text-gray mb-4 block"></i>
        <h1 className="text-xl md:text-2xl font-heading font-bold text-text-dark mt-6">哎呀，迷路啦！</h1>
        <p className="mt-2 text-sm text-text-muted font-mono">{location.pathname}</p>
        <p className="mt-4 text-sm text-text-muted">這個頁面不存在，也許是時空裂縫把它吞掉了～</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-6 bg-accent-orange hover:bg-accent-orange/90 text-white text-sm font-semibold px-6 py-2.5 rounded-full transition-all duration-200 cursor-pointer"
        >
          <i className="ri-arrow-left-line"></i>
          回到首頁
        </Link>
      </div>
    </div>
  );
}